<div class="container mt-4">
   <div class="col-lg-8 col-md-6 col-sm-12">
  <h1><b>Shipping & Returns Policy</b></h1>

  <h1>Shipping Policy</h1>
  <h3><b>Processing Time</b></h3> 

<p>Most handmade items are processed within 3–7 business days. Custom orders may require additional production time.</p>

<h3><b>Shipping Time</b></h3>

<h3>Estimated delivery times:</h3>

<li>United States: 3–10 business days</li>
<li>International: 7–30 business days</li>

<p>Delivery times are estimates and are not guaranteed.</p>

<h3><b>Shipping Delays</b></h3>

<p>We are not responsible for delays caused by shipping carriers, weather conditions, customs processing, or other circumstances beyond our control.</p>

<h3><b>Incorrect Addresses</b></h3>

<p>Customers are responsible for providing accurate shipping information. Additional shipping charges may apply if a package must be resent due to an incorrect address.</p>

  <h3><b>Lost or Damaged Packages</b></h3>

<p>Please contact us within 7 days of delivery if your package arrives damaged. We will work with the shipping carrier to help resolve the issue.</p>

   <h1>Return & Refund Policy</h1>
  <h3><b>Returns</b></h3>
  <p>
    We accept returns within 14 days of delivery for eligible items.
  </p>
  <h4>Items must:</h4>
  <li>	Be unused</li>
  <li>	Be in original condition</li>
  <li>	Be returned in original packaging when possible</li> <br>

  <h4>Non-Returnable Items</h4>
  <p>
   The following items cannot be returned:
  </p>
   <li>Custom-made items</li>
   <li>Personalized items</li>
   <li>Digital products</li>
   <li>Sale or clearance items</li><br>
  <h3><b>Refunds</b></h3>
  <p>
   Once the returned item is received and inspected, we will notify you of approval or rejection of your refund.</p>

   <p>Approved refunds will be issued to the original payment method within 5–10 business days.</p>

   <h4><b>Return Shipping</b></h4>

   <p>Customers are responsible for return shipping costs unless the item arrived damaged or we made an error with the order.</p>

  <p>
    Approved refunds will be processed to your original payment method within 5-10 business days.
  </p>
   <h1>Custom Order Policy</h1>

 <h3><b>Custom Orders</b></h3>

<p>We love creating personalized crochet items. Custom orders are made according to the specifications provided by the customer.</p>
 <h3><b>Production Time</b></h3>

<p>Custom orders generally require 1–4 weeks depending on complexity and workload.</p>
<h3><b>Design Approval</b></h3>

<p>Customers should carefully review all design details before production begins.</p>

<h3><b>Changes to Orders</b></h3>

<p>Changes may be requested before production starts. Once work has begun, changes may not be possible.</p>

<h3><b>Cancellations</b></h3>

<p>Custom orders may be canceled within 24 hours of purchase. After production begins, cancellations are generally not eligible for refunds.</p>

<h3><b>Handmade Variations</b></h3>

<p>Each custom crochet item is handmade and unique. Slight variations from photos or sketches are normal and expected.</p>

  <h3><b>Contact Us</b></h3>
  <p>
   We are happy to help with questions, custom requests, and order support.</p>

<h3>Skybeth Crochet</h3>

<h4>Email: Skybeth2026@gmail.com</h4>

<li>Business Hours:</li>
<li>Monday – Friday</li>
<li>9:00 AM – 5:00 PM (EST)</li>

<p>Response Time:</p>
<p>We aim to respond to all inquiries within 24–48 business hours.</p> 

<p>For order-related questions, please include:</p>

 <li>Your order number</li>
<li>Your name</li>	
<li>A description of your inquiry</li>	

<p>Thank you for supporting handmade crochet creations at Skybeth Crochet! </p>

  </div>
</div>
<br>
